import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f6d8908"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "sidebarMenu",
  class: "col-12 d-block sidebar collapse"
}
const _hoisted_2 = { class: "position-sticky pt-1 mb-3" }
const _hoisted_3 = { class: "text-center mb-2" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "text-center mb-2" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "position-sticky pt-1 mb-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-center mb-2" }, " Versão 1.6.11.23 ")
], -1))
const _hoisted_7 = { class: "position-sticky pt-1 mb-3 border-bottom" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Funções ")
const _hoisted_9 = { class: "nav flex-column" }
const _hoisted_10 = { class: "position-sticky pt-2 mb-3 border-bottom" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "nav flex-column" }
const _hoisted_13 = { class: "position-sticky pt-4 mb-3" }
const _hoisted_14 = { class: "text-center mb-4" }
const _hoisted_15 = ["src"]
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Perfil ")
const _hoisted_17 = { class: "text-center mb-4" }
const _hoisted_18 = ["src"]
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Sair")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: `${$setup.apiData.urlimg}${$setup.user.foto}`,
          alt: "",
          width: "70",
          height: "80",
          class: "rounded-circle me-2"
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, _toDisplayString($setup.user.first_name) + " " + _toDisplayString($setup.user.last_name), 1)
    ]),
    _hoisted_6,
    _createElementVNode("div", _hoisted_7, [
      ($setup.apiData.showMFunc)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            href: "javascript:void(0)",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.fselect()))
          }, [
            _createElementVNode("h5", null, [
              _createVNode(_component_font_awesome_icon, {
                icon: $setup.fselected === 1 ? 'angle-down': 'angle-right'
              }, null, 8, ["icon"]),
              _hoisted_8
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["overflow-hidden", $setup.fselected === 1 ? 'show' : 'hide'])
      }, [
        _createElementVNode("ul", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.funcdisp, (f) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "nav-item",
              key: f.id
            }, [
              _createVNode(_component_router_link, {
                to: `${f.funcdisp.route}/${'f'}/${f.funcdisp.id}/0`,
                class: "nav-link",
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.closeMenu()))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_font_awesome_icon, {
                    icon: `${f.funcdisp.icon}`
                  }, null, 8, ["icon"]),
                  _createTextVNode(" " + _toDisplayString(f.funcdisp.short_name), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]))
          }), 128))
        ])
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_10, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.perfilfuncdisp, (p) => {
        return (_openBlock(), _createElementBlock("ul", {
          class: "nav flex-column",
          key: p.profile_disp_menu.id
        }, [
          _createElementVNode("a", {
            href: "javascript:void(0)",
            onClick: ($event: any) => ($setup.select(p.profile_disp_menu.id))
          }, [
            _createElementVNode("h5", null, [
              _createVNode(_component_font_awesome_icon, {
                icon: $setup.selected === p.profile_disp_menu.id ? 'angle-down': 'angle-right'
              }, null, 8, ["icon"]),
              _createTextVNode(" " + _toDisplayString(p.profile_disp_menu.short_name), 1)
            ])
          ], 8, _hoisted_11),
          _createElementVNode("div", {
            class: _normalizeClass(["overflow-hidden", $setup.selected === p.profile_disp_menu.id ? 'show' : 'hide'])
          }, [
            _createElementVNode("ul", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.funcprofdisp, (pf) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "nav-item",
                  key: pf.id
                }, [
                  _createVNode(_component_router_link, {
                    to: `${pf.funcdisp.route}/${'p'}/${pf.funcdisp.id}/${p.profile_disp_menu.id}`,
                    class: "nav-link",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.closeMenu()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_font_awesome_icon, {
                        icon: `${pf.funcdisp.icon}`
                      }, null, 8, ["icon"]),
                      _createTextVNode(" " + _toDisplayString(pf.funcdisp.short_name), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]))
              }), 128))
            ])
          ], 2)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_router_link, {
          to: "/profile",
          class: "d-flex align-items-center text-dark text-decoration-none",
          onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.closeMenu()))
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: `${$setup.apiData.urlimg}images/menu/perfil.png`,
              alt: "",
              width: "25",
              height: "25",
              class: "rounded-circle me-2"
            }, null, 8, _hoisted_15),
            _hoisted_16
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("a", {
          href: "#",
          class: "d-flex align-items-center text-dark",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.logout && $setup.logout(...args)))
        }, [
          _createElementVNode("img", {
            src: `${$setup.apiData.urlimg}images/menu/sair.png`,
            alt: "",
            width: "25",
            height: "25",
            class: "rounded-circle me-2"
          }, null, 8, _hoisted_18),
          _hoisted_19
        ])
      ])
    ])
  ]))
}